export const NON_DIGITS_REGEX = /([^\d+])/g;

const USA_PREFIX = '(\\+?1)?';
const COUNTRY_CODE_OR_START_OF_FIRST_THREE_DIGITS = '([2-9]\\d{0,2})';
const FIRST_THREE_DIGITS_OR_REMAINDER_OF_FIRST_THREE_DIGITS = '(\\d{1,3})?';
const REST_OF_PHONE_NUMBER = '(\\d*)?';
export const PHONE_NUMBER_REGEX = new RegExp(
    `^${USA_PREFIX}${COUNTRY_CODE_OR_START_OF_FIRST_THREE_DIGITS}${FIRST_THREE_DIGITS_OR_REMAINDER_OF_FIRST_THREE_DIGITS}${REST_OF_PHONE_NUMBER}$`
);

/**
 * Converts a string into a phone number, preferring x (xxx) xxx-xxxx, but supporting (xxx) xxx-xxxx or xxx-xxxx as well
 * @param input string to convert into a phone number in the formats above
 * @returns a string representation of a phone number
 */
export const formatPhoneNumber = (input: string) => {
    const digits = input.replace(NON_DIGITS_REGEX, '').replace(/^\+?1/, '');
    const matches = digits.match(PHONE_NUMBER_REGEX);
    if (!matches) {
        return null;
    }
    const [, _, areaCode, firstThree, rest] = matches;
    return [`(${areaCode}`, firstThree ? `) ${firstThree}` : '', rest ? `-${rest}` : ''].join('');
};
